import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { LoaderSpinner } from '../components/LoaderSpinner';

const getEdenBaseURL = () => {
  const env = process.env.REACT_APP_KL_ENV;
  if (env === "beta") return "https://kingsloot-beta-qgqri.ondigitalocean.app";
  if (env === "prod") return "https://eden.kingsloot.com";
  return 'http://localhost:3001';
};

const DownloadPage = () => {
  const { type, id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [downloading, setDownloading] = useState(true);

  useEffect(() => {
    const triggerDownload = async () => {
      if (!type || !id) {
        setError('Invalid download link');
        setDownloading(false);
        return;
      }

      try {
        let downloadUrl;
        let filename;
        let contentType;

        if (type === 'shipping-labels') {
          downloadUrl = `${getEdenBaseURL()}/api/v1/public/purchase-order/${id}/shipping-labels/download`;
          filename = `shipping-labels-${id}.pdf`;
          contentType = 'application/pdf';
        } else if (type === 'epc') {
          downloadUrl = `${getEdenBaseURL()}/api/v1/management/purchase-order/${id}/epcs/download`;
          filename = `po_${id}_epcs.csv`;
          contentType = 'text/csv';
        } else if (type === 'po') {
          downloadUrl = `${getEdenBaseURL()}/api/v1/public/purchase-order/${id}/po/download`;
          filename = `po-${id}.pdf`;
          contentType = 'application/pdf';
        } else {
          setError('Invalid download type');
          setDownloading(false);
          return;
        }

        // Fetch the file - fetch will follow redirects automatically
        const response = await fetch(downloadUrl, {
          method: 'GET',
          redirect: 'follow', // Explicitly follow redirects
        });

        if (!response.ok) {
          throw new Error(`Failed to download: ${response.statusText}`);
        }

        // Get the blob data
        const blob = await response.blob();
        
        // Create a temporary URL and trigger download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        setDownloading(false);
        
        // Redirect to home after a short delay
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 2000);
      } catch (err) {
        console.error('Download error:', err);
        setError(err.message || 'Failed to download file');
        setDownloading(false);
      }
    };

    triggerDownload();
  }, [type, id, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        {downloading ? (
          <div>
            <LoaderSpinner width="48" height="48" border="4" colorSpinner="blue" />
            <p className="mt-4 text-gray-600">Preparing download...</p>
          </div>
        ) : error ? (
          <div>
            <p className="text-red-600 text-lg mb-4">Error: {error}</p>
            <button
              onClick={() => navigate('/', { replace: true })}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Go Home
            </button>
          </div>
        ) : (
          <div>
            <p className="text-green-600 text-lg mb-4">Download started!</p>
            <p className="text-gray-600 text-sm">Redirecting...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DownloadPage;

